export default class ItemAction {
  /**
   * 
   * @param {object} info
   * @param {*} info.action the action 
   * @param {*} info.x 
   * @param {*} info.y 
   * @param {*} info.rotation 
   * @param {*} info.itemRef 
   * @param {*} info.itemSpriteName 
   */
  constructor(info) {
    this.action = info.action ?? null;
    this.x = info.x ?? null;
    this.y = info.y ?? null;
    this.itemRef = info.itemRef ?? null;
    this.itemSpriteName = info.itemSpriteName ?? null;
    this.rotation = info.rotation ?? null;
  }
}